import R from 'ramda';

import {
  CanonicalCollections,
  TranslatedCollectionToCanonical,
} from 'ha/constants/SearchPageCollections';

const defaultStats = { averagePrice: 0 };

const getPriceFacet = (city, country) => ({
  query: '',
  params: {
    distinct: true,
    facets: 'priceEUR',
    hitsPerPage: 0,
    filters: `city:'${city}' AND country:'${country}' AND isSearchable:true`,
  },
});

// Although the location might be localized, we need the canonical city and country for algolia queries.
const getCanonicalLocation = (location, apiV2) =>
  apiV2.searchCity({ query: location, languages: ['en'] }).then(response => ({
    city: response.data.en.cityCanonical,
    country: response.data.en.countryCanonical,
  }));

export default (translatedCollection, location) => (
  _dispatch,
  _getState,
  { algolia, apiV2 },
) => {
  if (
    !translatedCollection ||
    TranslatedCollectionToCanonical[translatedCollection] !==
      CanonicalCollections.CheapAccommodation
  ) {
    return Promise.resolve(defaultStats);
  }

  return getCanonicalLocation(location, apiV2)
    .then(({ city, country }) =>
      algolia
        .searchListings([getPriceFacet(city, country)])
        .then(response => response.results[0])
        .then(price => ({
          averagePrice: Math.round(
            R.pathOr(0, ['priceEUR', 'avg'], price.facets_stats) * 100,
          ),
        })),
    )
    .catch(() => defaultStats);
};
